<div class="fuse-drawer-content flex flex-col shadow-2xl"
     [ngClass]="{ 'w-half' : sizeType === 'half', 'w-large': sizeType === 'large' }">
    <div class="sticky top-0 z-50 bg-card">
        @if (showUpBand) {
            <div class="up-band w-full" [ngClass]="{'h-[40px]': showCloseButton && !isScreenSmall}">
                @if (showCloseButton && !isScreenSmall) {
                    <div class="flex items-end justify-end w-full ">
                        <button mat-icon-button (click)="close()">
                            <mat-icon
                                class="dark:text-white"
                                svgIcon="heroicons_outline:x"></mat-icon>
                        </button>
                    </div>
                }
            </div>
        } @else {
            @if (showCloseButton && !isScreenSmall) {
                <div class="close-button absolute top-0 right-0 p-4">
                    <button mat-icon-button (click)="close()">
                        <mat-icon svgIcon="heroicons_outline:x"></mat-icon>
                    </button>
                </div>
            }
        }
    </div>

    <ng-content></ng-content>

    @if (_currentTemplate && _currentTemplate.buttons && _currentTemplate.buttons.length > 0) {
        <sbd-doug-frontend-common-drawer-footer
            [buttons]="_currentTemplate.buttons"
            [buttonPosition]="'between'"
            [componentRef]="_componentRef"
            (buttonClick)="onFooterButtonClickEvent($event)">
        </sbd-doug-frontend-common-drawer-footer>
    }

</div>
